import { render, staticRenderFns } from "./DialoguePage.vue?vue&type=template&id=16cefe76&scoped=true&"
import script from "./DialoguePage.vue?vue&type=script&lang=js&"
export * from "./DialoguePage.vue?vue&type=script&lang=js&"
import style0 from "./DialoguePage.vue?vue&type=style&index=0&id=16cefe76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cefe76",
  null
  
)

export default component.exports